import {Analytics} from '../../services/analytics/Analytics';

export function trackPageViewed(page: string, tab?: string) {
  window.analytics?.page(page, {tab});
}

export function trackBreadcrumbClicked(destination: string) {
  Analytics.track('Top nav breadcrumb clicked', {destination});
}

export function trackProjectTabClicked(opts: {[key: string]: any}) {
  Analytics.track('Project tab clicked', opts);
}

export function trackModelRegistryClicked(location: string) {
  Analytics.track('Model registry clicked', {
    location,
  });
}

export function trackLaunchClicked(location: string) {
  Analytics.track('Launch clicked', {
    location,
  });
}

export function trackCreatePortfolioButtonClicked(location: string) {
  Analytics.track('Create Portfolio button clicked', {
    location,
  });
}

export function trackModelRegistryLimitsReached(limitType: string) {
  Analytics.track('Model Registry Limits Reached in App', {limitType});
}

export function trackArtifactInteraction(opts: {[key: string]: any}) {
  Analytics.track('Artifact interaction', opts);
}

export function trackModelRegistryAccessControlsInteraction(opts: {
  [key: string]: any;
}) {
  Analytics.track('Model registry access controls interaction', opts);
}

export function trackArtifactLineageTabInteraction(dagView: string) {
  Analytics.track('Artifact lineage tab view selected', {
    dagView,
  });
}

export function trackArtifactCollectionSettingsSelected(opts: {
  [key: string]: any;
}) {
  Analytics.track('Artifact collection settings view selected', {opts});
}

export function trackCreateTriggerClicked(location: string) {
  Analytics.track('Create Trigger button clicked', {location});
}

export function trackLaunchConfigUpdated(opts: {[key: string]: any}) {
  Analytics.track('Trigger config updated', {opts});
}

export function trackAutomatedNotificationsEnabled(opts: {[key: string]: any}) {
  Analytics.track('Automated notifications enabled for artifact collections', {
    opts,
  });
}
